export default class HttpService {
  static readonly API_BASE_URL = 'https://respondent-matcher-backend.herokuapp.com/api';

  static async uploadFileRequest(
    endpoint: string,
    body: FormData
  ): Promise<object> {
    try {
      const response = await fetch(`${this.API_BASE_URL}/${endpoint}`, {
        method: "POST",
        body
      });
      return Promise.resolve(response.json());
    } catch (error) {
      return Promise.reject(error);
    }
  }
}
